import styled from 'styled-components'

export const NearProductsWrapper = styled.div`
  margin-top: auto;
  z-index: 1;
`
